import React from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { Typography } from '@fiverr-private/typography';
import { PriceConverter } from '@fiverr-private/listing_lib';
import { PriceBucket } from './PriceBuckets';

const TIER_KEYS = ['value', 'mid_range', 'high_end'] as const;

const PriceBucketText = ({ text }: { text?: string }) => (
    <span className="tbody-6 m-l-8 co-text-medium text-normal">{text}</span>
);

const templates = {
    bucket_text: (text?: string) => <PriceBucketText text={text} />,
};

const getTierParams = (priceBucket: PriceBucket, currency: { code: string }, index: number) => {
    const priceConverter = new PriceConverter(currency);
    const { min, max } = priceBucket;
    const minLocalized = priceConverter.getLocalizedPrice(min * 100, { noFractionDigits: true });
    const maxLocalized = priceConverter.getLocalizedPrice(max * 100, { noFractionDigits: true });

    return [{ price: maxLocalized }, { min_price: minLocalized, max_price: maxLocalized }, { price: minLocalized }][
        index
    ];
};

export const formatPrice = (priceBucket: PriceBucket, index: number, currency: { code: string }) => {
    const tierKey = TIER_KEYS[index];

    if (!tierKey) {
        return undefined;
    }

    return translate(`search_perseus.filters.global.price_buckets.${tierKey}`, {
        params: getTierParams(priceBucket, currency, index),
        templates,
    });
};

export const formatFilterRowPrice = (priceBucket: PriceBucket, index: number, currency: { code: string }) => {
    const tierKey = TIER_KEYS[index];

    if (!tierKey) {
        return undefined;
    }

    return (
        <Typography as="span">
            {translate(`search_perseus.filters.global.price_buckets.filter_row_alias.${tierKey}`, {
                params: getTierParams(priceBucket, currency, index),
            })}
        </Typography>
    );
};
